// react
import { useEffect } from 'react';

// api
import { useGetSessionQuery } from '@/api/auth-server/authServerApiSlice';

export function useSilentAuthGuard() {
  const { data, error, isLoading } = useGetSessionQuery();

  useEffect(() => {
    const isOnSilentLogin =
      window.location.pathname.startsWith('/auth/silent-login');
    if (isLoading || isOnSilentLogin) return;

    if (data?.authenticated === false) {
      const returnTo = window.location.pathname + window.location.search;
      window.location.href = `/auth/silent-login?returnTo=${encodeURIComponent(returnTo)}`;
    }

    if (error) {
      console.warn('Auth check failed', error);
    }
  }, [data, isLoading, error]);
}
